import React, { useEffect, useState } from 'react';
import ProgressHeader from '../../components/ProgressHeader/index.jsx';
import GenerateTable from '../../components/GenerateTable/index.jsx';
import GenerateLayout from '../../components/GenerateLayout/index.jsx';
import { useRoot } from '../../hooks/useRoot.jsx';
import TutorialWin from '../../components/TutorialWin/index.jsx';
import ResultCom from '../../components/ResultCom/index.jsx';
import { PCISFIRST } from '../../utils/utils.ts';

const HomePage = () => {
  const { step } = useRoot();
  const [ showTutorWin, setShowTutorWin ] = useState(false);

  useEffect(() => {
    const isFirst = sessionStorage.getItem(PCISFIRST);
    if(!isFirst) {
      setShowTutorWin(true);
    }
  }, []);

  return <>
    <div className='flex-1 flex flex-col h-0'>
      <ProgressHeader step={step}></ProgressHeader>
      <div className='h-[15px] flex-none'></div>
      {
        step === 1 && <GenerateTable></GenerateTable>
      }
      {
        step === 2 && <GenerateLayout></GenerateLayout>
      }
      {
        step === 3 && <ResultCom></ResultCom>
      }
    </div>
    <TutorialWin show={showTutorWin} onClose={setShowTutorWin}></TutorialWin>
  </>;
};

export default HomePage;